//#region src/utils/semver/compare.ts
function compareAtom(rangeAtom, versionAtom) {
    rangeAtom = Number(rangeAtom) || rangeAtom;
    versionAtom = Number(versionAtom) || versionAtom;
    if (rangeAtom > versionAtom) return 1;
    if (rangeAtom === versionAtom) return 0;
    return -1;
}
function comparePreRelease(rangeAtom, versionAtom) {
    var rangePreRelease = rangeAtom.preRelease;
    var versionPreRelease = versionAtom.preRelease;
    if (rangePreRelease === void 0 && Boolean(versionPreRelease)) return 1;
    if (Boolean(rangePreRelease) && versionPreRelease === void 0) return -1;
    if (rangePreRelease === void 0 && versionPreRelease === void 0) return 0;
    for(var i = 0, n = rangePreRelease.length; i <= n; i++){
        var rangeElement = rangePreRelease[i];
        var versionElement = versionPreRelease[i];
        if (rangeElement === versionElement) continue;
        if (rangeElement === void 0 && versionElement === void 0) return 0;
        if (!rangeElement) return 1;
        if (!versionElement) return -1;
        return compareAtom(rangeElement, versionElement);
    }
    return 0;
}
function compareVersion(rangeAtom, versionAtom) {
    return compareAtom(rangeAtom.major, versionAtom.major) || compareAtom(rangeAtom.minor, versionAtom.minor) || compareAtom(rangeAtom.patch, versionAtom.patch) || comparePreRelease(rangeAtom, versionAtom);
}
function eq(rangeAtom, versionAtom) {
    return rangeAtom.version === versionAtom.version;
}
function compare(rangeAtom, versionAtom) {
    switch(rangeAtom.operator){
        case "":
        case "=":
            return eq(rangeAtom, versionAtom);
        case ">":
            return compareVersion(rangeAtom, versionAtom) < 0;
        case ">=":
            return eq(rangeAtom, versionAtom) || compareVersion(rangeAtom, versionAtom) < 0;
        case "<":
            return compareVersion(rangeAtom, versionAtom) > 0;
        case "<=":
            return eq(rangeAtom, versionAtom) || compareVersion(rangeAtom, versionAtom) > 0;
        case void 0:
            return true;
        default:
            return false;
    }
}
//#endregion
exports.compare = compare; //# sourceMappingURL=compare.cjs.map
